export default __webpack_public_path__ + "static/media/bean-bg.86fa3efc.webp";